// src/pages/admin/AdminKYC.js
import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminKYC() {
  const [users, setUsers] = useState([]);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectId, setRejectId] = useState(null);

  const load = () => api.get('/admin/kyc-queue').then(r => setUsers(r.data.users || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const approve = async (id) => {
    try {
      await api.put(`/admin/users/${id}/kyc`, { status: 'verified' });
      toast.success('KYC approved! GCI ID assigned.');
      load();
    } catch (err) { toast.error(err.response?.data?.message || 'Failed'); }
  };

  const reject = async (id) => {
    if (!rejectReason) return toast.error('Please enter rejection reason');
    try {
      await api.put(`/admin/users/${id}/kyc`, { status: 'rejected', reason: rejectReason });
      toast.success('KYC rejected. User notified.');
      setRejectId(null);
      setRejectReason('');
      load();
    } catch (err) { toast.error('Failed'); }
  };

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">KYC <span style={{ color: 'var(--neon-yellow)' }}>VERIFICATION QUEUE</span></h1>
      <p style={{ color: 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.75rem', marginTop: '0.5rem', marginBottom: '2rem' }}>
        {users.length} user{users.length !== 1 ? 's' : ''} pending KYC verification
      </p>

      {users.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '4rem', color: 'var(--muted)', fontFamily: 'Space Mono, monospace' }}>
          ✅ No pending KYC applications
        </div>
      ) : users.map(u => (
        <div key={u.id} className="card" style={{ marginBottom: '1rem', borderLeft: '3px solid var(--neon-yellow)' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '2rem', alignItems: 'start' }}>
            <div>
              <div style={{ fontFamily: '"Plus Jakarta Sans", sans-serif', fontSize: '1.3rem', letterSpacing: '2px', marginBottom: '0.3rem' }}>{u.name}</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '1rem', marginTop: '1rem' }}>
                {[
                  { l: 'Email', v: u.email },
                  { l: 'Phone', v: u.phone },
                  { l: 'PAN', v: u.pan },
                  { l: 'Entity Type', v: u.entity_type },
                  { l: 'Sector', v: u.sector },
                  { l: 'GSTIN', v: u.gstin || 'N/A' },
                  { l: 'Registered', v: new Date(u.created_at).toLocaleDateString('en-IN') },
                  { l: 'KYC Status', v: u.kyc_status?.replace('_', ' ').toUpperCase() },
                ].map(({ l, v }) => (
                  <div key={l}>
                    <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.55rem', letterSpacing: '2px', color: 'var(--muted)', textTransform: 'uppercase', marginBottom: '0.2rem' }}>{l}</div>
                    <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.75rem' }}>{v}</div>
                  </div>
                ))}
              </div>
              <div style={{ marginTop: '1rem' }}>
                <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.6rem', color: 'var(--muted)', letterSpacing: '2px', marginBottom: '0.3rem' }}>ADDRESS</div>
                <div style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.75rem' }}>{u.address}</div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
              <button className="btn btn-primary" style={{ justifyContent: 'center' }} onClick={() => approve(u.id)}>
                ✅ APPROVE KYC
              </button>
              <button className="btn btn-danger" style={{ justifyContent: 'center' }} onClick={() => setRejectId(rejectId === u.id ? null : u.id)}>
                ✗ REJECT KYC
              </button>
              {rejectId === u.id && (
                <div>
                  <textarea className="form-textarea" value={rejectReason} onChange={e => setRejectReason(e.target.value)} placeholder="Rejection reason (required)..." rows={3} style={{ marginBottom: '0.5rem' }} />
                  <button className="btn btn-danger" style={{ width: '100%', justifyContent: 'center' }} onClick={() => reject(u.id)}>CONFIRM REJECT</button>
                </div>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
